import { render, staticRenderFns } from "./ontherMarkets.vue?vue&type=template&id=dc4d50ee&scoped=true"
import script from "./ontherMarkets.vue?vue&type=script&lang=js"
export * from "./ontherMarkets.vue?vue&type=script&lang=js"
import style0 from "./ontherMarkets.vue?vue&type=style&index=0&id=dc4d50ee&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc4d50ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod-gz-clzjn-management-platform-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc4d50ee')) {
      api.createRecord('dc4d50ee', component.options)
    } else {
      api.reload('dc4d50ee', component.options)
    }
    module.hot.accept("./ontherMarkets.vue?vue&type=template&id=dc4d50ee&scoped=true", function () {
      api.rerender('dc4d50ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/module/otherMarket/views/ontherMarkets.vue"
export default component.exports